
const questionReducer = (state= {items:[]},action)=>{
    switch (action.type) {
        case 'QUESTION':
            return {
                items: action.payload,

            };

        default:
            return state;

    }
}
export default questionReducer;